import { create } from "zustand"
import { DocLinkComponet } from "../types"

interface DocStore {
  presentation:
    | {
        doc?: DocLinkComponet
        side?: "left" | "right"
      }
    | undefined
  present: (doc: DocLinkComponet, side?: "left" | "right") => void
  openRemotely: (doc?: DocLinkComponet) => void
  dismiss: () => void
}

export const useDocStore = create<DocStore>((set, get) => ({
  openRemotely(doc) {
    if (!doc) doc = get().presentation?.doc
    if (!doc) return
    window.open(doc.link, "_blank")
  },
  present(doc, side) {
    set({
      presentation: {
        doc,
        side,
      },
    })
  },
  dismiss() {
    set({
      presentation: {},
    })
  },
  presentation: undefined,
}))
